import { render } from "./ModelViewer.vue?vue&type=template&id=0dcac465&scoped=true"
import script from "./ModelViewer.vue?vue&type=script&lang=js"
export * from "./ModelViewer.vue?vue&type=script&lang=js"

import "./ModelViewer.vue?vue&type=style&index=0&id=0dcac465&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcac465"]])

export default __exports__